var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.lesson.lessonSlug === 'index')?_c('b-nav-item',{attrs:{"to":{ name: 'index', params: { courseSlug: _vm.courseSlug } }}},[_vm._v(_vm._s(_vm.lesson.lessonTitle)+" ")]):_vm._e(),(_vm.lesson.lessonSlug !== 'index')?_c('b-nav-item',{attrs:{"to":{
      name: 'lessons',
      params: { courseSlug: _vm.courseSlug, lessonSlug: _vm.link },
    }}},[_vm._v(_vm._s(_vm.lesson.lessonOrder)+". "+_vm._s(_vm.lesson.lessonTitle)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }